import { render, staticRenderFns } from "./setDevice.vue?vue&type=template&id=09c37d6e&scoped=true&"
import script from "./setDevice.vue?vue&type=script&lang=js&"
export * from "./setDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c37d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c37d6e')) {
      api.createRecord('09c37d6e', component.options)
    } else {
      api.reload('09c37d6e', component.options)
    }
    module.hot.accept("./setDevice.vue?vue&type=template&id=09c37d6e&scoped=true&", function () {
      api.rerender('09c37d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setDevice.vue"
export default component.exports